import { state } from "media/state"
import { userEventModule } from "user/event"

export function startMediaListeners(): void {
  userEventModule.on.login("media-login", () => {
    state.mediaInfoById = {}
  })
}
